import { Product } from './Product';
import { ITenant } from '../../domains/inventory/types';
import { Environment } from '../../config/env-config';
import { IProductViewModel } from './types/models';
import {
  xmCloudProduct as xmcloud,
  headlessCMSProduct as headlesscms,
  connectProduct as connect,
  orderCloudProduct as ordercloud,
  cdpProduct as cdp,
  personalizeProduct as personalize,
  searchProduct as search,
  discoverProduct as discover,
  sendProduct as send,
  damProduct as dam,
  contentOperationsProduct as contentoperations,
  aiProduct as ai,
} from '../../content';

export function getProductJsonData(productCode: ProductCode) {
  const productData = {
    xmcloud,
    headlesscms,
    connect,
    ordercloud,
    cdp,
    personalize,
    search,
    discover,
    send,
    dam,
    contentoperations,
    ai,
  }[productCode];

  return productData;
}

export function getProduct(tenant: ITenant, env: Environment): Product {
  const product = new Product({ tenant, env });

  return product;
}

export function filterValidProduct(product: Product) {
  return product.isValid && product.isOnboarded;
}

export function getProductInstances(tenants: ITenant[], env: Environment) {
  return tenants.map((t) => getProduct(t, env)).filter(filterValidProduct);
}

export function getProductInstancesView(tenants: ITenant[], env: Environment) {
  return getProductInstances(tenants, env).map((p) => p.viewModel);
}

export function getSortedTenants(tenants: ITenant[]) {
  return tenants.sort((tenant1, tenant2) => {
    // Only sort by name if not identical
    if (tenant1.name < tenant2.name) return -1;
    if (tenant1.name > tenant2.name) return 1;

    // Sort by displayName
    if (tenant1.displayName < tenant2.displayName) return -1;
    if (tenant1.displayName > tenant2.displayName) return 1;
  });
}

export function getDistinctProductInstanceByViewModelKey(
  tenants: ITenant[],
  arg: keyof IProductViewModel,
  env: Environment,
) {
  return [
    ...new Map(
      getProductInstances(tenants, env).map((p) => [p.viewModel[arg], p]),
    ).values(),
  ];
}

export function isNonProdEnvironment(envLabel: string): boolean {
  const nonProdEnvironments = ['nonprod', 'non-prod'];

  if (!envLabel) return false;

  return nonProdEnvironments.some((nonProdEnvLabel) =>
    envLabel.toLowerCase().includes(nonProdEnvLabel),
  );
}

export type ProductCode =
  | 'xmcloud'
  | 'headlesscms'
  | 'ordercloud'
  | 'connect'
  | 'cdp'
  | 'personalize'
  | 'search'
  | 'discover'
  | 'send'
  | 'dam'
  | 'contentoperations'
  | 'ai';
